import React from "react";
import { UiDashboardEmptyMessage } from "../ErrorMessages/UiEmptyScreens";
import emptyscreenDashboard from "../../../styles/img/empty-account-activities.png";

const UISchedulePaymentsEmpty = () => {
  return (
    <UiDashboardEmptyMessage
      icon={emptyscreenDashboard}
      className="df-empt-msg-acc df-empty-activities"
    >
      <h3>Uh-oh!</h3>
      <p>No schedules to display.</p>
    </UiDashboardEmptyMessage>
  );
};

export default UISchedulePaymentsEmpty;
